export default {
    env: process.env,
    foo: process.env.foo,
    bar: process.env.bar,
    // storage: {
    //     storageProvider:
    // },
    http: {
        base_url: '/api',
    },
    services: {
        graph: {
            clientId: process.env.GRAPH_CLIENT_ID,
            redirectUri: '',
            interactionMode: 'popUp',
            graphEndpoint: 'https://graph.microsoft.com/v1.0/me',
            graphScopes: ['user.read'],
        },
        password_reset: {
            url: 'https://passord.ikommservices.no/',
        },
        livechatinc: {
            licence: 7078401,
            group: 6,
            chat_between_groups: false,
        },
    },
}
